import { t } from '../../../common/i18n/index.js';
import {
  formatDeviceSelectionCount,
  getDeviceSelectionCategoryConfig,
} from '../../../common/utils/deviceSelectionCategoryUtilsCoCo.js';
import type { DeviceSelectionCategoryCountCoCo } from '../../../common/utils/deviceSelectionCategoryUtilsCoCo.js';

interface DeviceSelectionCountsCoCoProps {
  // BEM block of the parent, the elements are styled as `${blockClassName}__total` and `${blockClassName}__categories`
  blockClassName: string;
  categoryCounts: DeviceSelectionCategoryCountCoCo[];
  total: number;
}

// Total device count with the counts of the categories that have devices
export const DeviceSelectionCountsCoCo = ({
  blockClassName,
  categoryCounts,
  total,
}: DeviceSelectionCountsCoCoProps) => {
  const visibleCategoryCounts = categoryCounts.filter(({ count }) => count > 0);
  return (
    <>
      <div className={`${blockClassName}__total`}>{formatDeviceSelectionCount(t.MSV2('Selected in total'), total)}</div>
      {visibleCategoryCounts.length > 0 && (
        <ul className={`${blockClassName}__categories`}>
          {visibleCategoryCounts.map(({ category, count }) => (
            <li key={category}>
              {formatDeviceSelectionCount(getDeviceSelectionCategoryConfig(category).label(), count)}
            </li>
          ))}
        </ul>
      )}
    </>
  );
};
